<script>
  import { push } from 'svelte-spa-router'
  function goHome() {
    push('/');
  }
</script>

<div class="notfound">
    <h1>404</h1>
    <h2>Page non trouvée</h2>
    <p>
        La page que vous recherchez n’existe pas ou a été déplacée.
    </p>

    <button on:click={goHome}>Retour à l’accueil</button>
</div>

<style>
    .notfound {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        min-height: 80vh;
        color: #333;
    }

    h1 {
        font-size: 6rem;
        margin: 0;
        color: #e74c3c;
    }

    h2 {
        margin: 0.5rem 0 1rem;
        font-size: 1.8rem;
    }

    p {
        margin-bottom: 2rem;
        font-size: 1.1rem;
        color: #555;
    }

    button {
        padding: 0.6rem 1.2rem;
        font-size: 1rem;
        border: none;
        border-radius: 6px;
        background: #3498db;
        color: white;
        cursor: pointer;
        transition: background 0.2s ease;
    }

    button:hover {
        background: #2980b9;
    }
</style>